import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=3ed63a1e&scoped=true&"
var script = {}
import style0 from "./Shipping.vue?vue&type=style&index=0&id=3ed63a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed63a1e",
  null
  
)

export default component.exports